// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ZzhuV","header-with-font":"Header_header-with-font__femXe","fixed-header":"Header_fixed-header__yDrW8","header-scrolled":"Header_header-scrolled__0m2Sp"};